module.exports = __webpack_public_path__ + "img/bg.7a75a8fd.png";